/**
 * Picks the email closest to the search term among candidates.
 * Priority: startsWith > earliest indexOf match > shorter email.
 */
export const pickClosestSearchEmail = ({ emails = [], searchTerm = "" }) => {
  const term = String(searchTerm).toLowerCase().trim();
  if (!term || !Array.isArray(emails) || emails.length === 0) {
    return null;
  }

  const uniqueEmails = [
    ...new Set(
      emails
        .map((email) => String(email || "").trim())
        .filter((email) => email.length > 0)
    ),
  ];

  if (uniqueEmails.length === 0) {
    return null;
  }

  const scored = uniqueEmails
    .map((email) => {
      const emailLower = email.toLowerCase();
      const startsWith = emailLower.startsWith(term);
      const indexOf = emailLower.indexOf(term);
      const contains = indexOf >= 0;

      if (!contains && !startsWith) {
        return null;
      }

      return {
        email,
        startsWith: startsWith ? 1 : 0,
        indexOf: startsWith ? 0 : indexOf,
        length: email.length,
      };
    })
    .filter(Boolean);

  if (scored.length === 0) {
    return null;
  }

  scored.sort((a, b) => {
    if (b.startsWith !== a.startsWith) {
      return b.startsWith - a.startsWith;
    }
    if (a.indexOf !== b.indexOf) {
      return a.indexOf - b.indexOf;
    }
    if (a.length !== b.length) {
      return a.length - b.length;
    }
    return a.email.localeCompare(b.email);
  });

  return scored[0].email;
};
